/* istanbul ignore file */
// TODO: Create test file

import * as outfittingStore from './outfittingStore';

export default {
  ...outfittingStore,
  strict: true,
  namespaced: true,
};
